export const RUTAS = {
    ROOT: '/',
    LOGIN: 'login',
    HOME: 'home',
    APROBACIONES: 'aprobaciones',
    GRAFO: 'grafo',
    NOTIFICACIONES: 'notifications',
    REPORTES: '/reports',
    DASHBOARD: '/dashboard',
    LIMITES: '/limits',
    ADMIN_PANEL: 'admin',
    ADMIN: {
        USUARIOS: 'usuarios',
        GRUPOS: 'grupos',
        ETAPAS: 'etapas',
        PERFILES: 'perfiles',
        SECTORES_COMERCIALES: 'sectores-comerciales',
        EVENTOS: 'eventos',
    }
} as const
